<template>
    <div id="sList" @click="$emit('on-click')" :style="{ paddingLeft:( plr ? plr : 10) + 'px',paddingRight:( plr ? plr : 10) + 'px' }">
        <p><b><slot name="title"></slot></b> <span><slot name="day"></slot></span></p>
        <p><slot name="des"></slot></p>
    </div>
</template>
<script>
export default {
   props:['plr']
}
</script>
<style lang="">
    #sList{
        padding:10px;
        background: #fff;
        margin-bottom: 2px;
    }
    
    #sList:active{
        background: #dee9f8;
    }
    #sList span{
        float: right;
    }
</style>


// WEBPACK FOOTER //
// ../common/src/components/lyList.vue